<template>
    <div class="form-wrapper">
        <PanelInput v-model="localForm.name" :label="$t('ruleLabel')" placeholder="Enter Rule Label" :max-length="40" :formType="formType" :tooltip="tooltips.fileTypesPolicy.ruleLabel"/>
        <FileTypePolicyInput v-model:items="localForm.fileExtensionDaos" :label="$t('fileExtension')"
            placeholder="Enter extension (e.g. .ps1)" :hasDropdown="true" :tooltip="tooltips.fileTypesPolicy.fileExtension" />
        <FileTypePolicyInput v-model:items="localForm.fileExtensionApps" :label="$t('applications')"
            placeholder="Enter application (e.g. wscript.exe)" :hasDropdown="false" :tooltip="tooltips.fileTypesPolicy.applications" />
        <ExpertNotes v-model="localForm.expertNotes" :max-length="1000" label="Expert Notes" />
    </div>
</template>
<script setup>
import { defineProps, ref, defineEmits, watch, computed } from 'vue'
import PanelInput from './components/panelInput.vue'
import FileTypePolicyInput from './components/fileTypePolicyInput.vue'
import ExpertNotes from './components/expertNotes.vue';
import tooltips from '@/assets/tooltips/en.json'
const props = defineProps({
    form: {
        type: Object,
        required: true,
        default: () => ({
            name: "",
            fileExtensionDaos: [],
            fileExtensionApps: []
        })
    },
    modelValue: {
        type: Object,
        required: true,
    },
    row: Object,
    formType: {
        type: String,
        default: 'fileTypePolicy'
    }
})
const emit = defineEmits(['update:form', 'update:modelValue'])
const localForm = computed({
    get() {
        return props.form;
    },
    set(newVal) {
        emit('update:form', newVal);
    }
});

</script>
<style>
.form-wrapper {
    font-size: 0.8rem !important;
    padding-right: 1rem;
}
</style>